// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#doses .dose-entry {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid var(--main-foreground-color);
  border-radius: 999px;
  width: 12.1rem;
  height: 12.1rem;
  margin: 0 auto;
  cursor: pointer;
  --action-distance: 6.5rem;
}

#doses .dose-entry.letter {
  width: 6.05rem;
  height: 6.05rem;
  --action-distance: 3.25rem;
}

#doses .dose-entry.latest {
  outline: 2px solid var(--secondary-color);
  outline-offset: 0.3rem;
}

#doses .entry-actions {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

#doses .entry-action {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2.2rem;
  height: 2.2rem;
  margin: -0.95rem 0 0 -0.95rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid var(--main-foreground-color);
  border-radius: 50%;
  background-color: var(--main-background-color);
  color: var(--main-foreground-color);
  opacity: 0;
  transform: rotate(var(--angle)) translate(0, calc(-1 * var(--action-distance))) rotate(calc(-1 * var(--angle))) scale(0.6);
  transition: opacity 0.15s ease, transform 0.15s ease;
}

#doses .entry-action.edit {
  --angle: 30deg;
}

#doses .entry-action.delete {
  --angle: 60deg;
}

#doses .entry-action.mark {
  --angle: 240deg;
  font-size: 1rem;
  font-weight: 600;
}

#doses .entry-action:hover {
  background-color: var(--main-foreground-color);
  color: var(--main-background-color);
}

#doses .dose-entry.active .entry-action {
  opacity: 1;
  pointer-events: auto;
  transform: rotate(var(--angle)) translate(0, calc(-1 * var(--action-distance))) rotate(calc(-1 * var(--angle))) scale(1);
}

@media (hover: hover) {
  #doses .dose-entry:hover .entry-action {
    opacity: 1;
    pointer-events: auto;
    transform: rotate(var(--angle)) translate(0, calc(-1 * var(--action-distance))) rotate(calc(-1 * var(--angle))) scale(1);
  }
}

#doses .datetime {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#doses .date {
  margin: 0;
  font-size: 1rem;
  color: var(--light-grey-color);
}

#doses .time {
  margin: 0;
  text-align: start;
  font-size: 3rem;
  color: var(--header-color);
}

#doses .dose-size {
  position: relative;
  top: 0.5rem;
  font-size: 1.2rem;
  margin-bottom: 0.1em;
}

#doses .dose-size .size {
  font-size: 2.2rem;
  color: var(--secondary-color);
}

#doses .dose-entry.letter .time {
  font-size: 1.5rem;
}

#doses .dose-entry.letter .dose-size {
  top: 0.25rem;
}

#doses .dose-size .size.letter {
  font-size: 1.32rem;
}

#doses .dose-size .ml {
  margin-inline-start: 5px;
  color: var(--light-grey-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/entries/DoseEntry.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,kBAAkB;EAClB,8CAA8C;EAC9C,mCAAmC;EACnC,UAAU;EACV,0HAA0H;EAC1H,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,wHAAwH;AAC1H;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;IACpB,wHAAwH;EAC1H;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC","sourcesContent":["#doses .dose-entry {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid var(--main-foreground-color);\n  border-radius: 999px;\n  width: 12.1rem;\n  height: 12.1rem;\n  margin: 0 auto;\n  cursor: pointer;\n  --action-distance: 6.5rem;\n}\n\n#doses .dose-entry.letter {\n  width: 6.05rem;\n  height: 6.05rem;\n  --action-distance: 3.25rem;\n}\n\n#doses .dose-entry.latest {\n  outline: 2px solid var(--secondary-color);\n  outline-offset: 0.3rem;\n}\n\n#doses .entry-actions {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n#doses .entry-action {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 2.2rem;\n  height: 2.2rem;\n  margin: -0.95rem 0 0 -0.95rem;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid var(--main-foreground-color);\n  border-radius: 50%;\n  background-color: var(--main-background-color);\n  color: var(--main-foreground-color);\n  opacity: 0;\n  transform: rotate(var(--angle)) translate(0, calc(-1 * var(--action-distance))) rotate(calc(-1 * var(--angle))) scale(0.6);\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n#doses .entry-action.edit {\n  --angle: 30deg;\n}\n\n#doses .entry-action.delete {\n  --angle: 60deg;\n}\n\n#doses .entry-action.mark {\n  --angle: 240deg;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n#doses .entry-action:hover {\n  background-color: var(--main-foreground-color);\n  color: var(--main-background-color);\n}\n\n#doses .dose-entry.active .entry-action {\n  opacity: 1;\n  pointer-events: auto;\n  transform: rotate(var(--angle)) translate(0, calc(-1 * var(--action-distance))) rotate(calc(-1 * var(--angle))) scale(1);\n}\n\n@media (hover: hover) {\n  #doses .dose-entry:hover .entry-action {\n    opacity: 1;\n    pointer-events: auto;\n    transform: rotate(var(--angle)) translate(0, calc(-1 * var(--action-distance))) rotate(calc(-1 * var(--angle))) scale(1);\n  }\n}\n\n#doses .datetime {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n#doses .date {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--light-grey-color);\n}\n\n#doses .time {\n  margin: 0;\n  text-align: start;\n  font-size: 3rem;\n  color: var(--header-color);\n}\n\n#doses .dose-size {\n  position: relative;\n  top: 0.5rem;\n  font-size: 1.2rem;\n  margin-bottom: 0.1em;\n}\n\n#doses .dose-size .size {\n  font-size: 2.2rem;\n  color: var(--secondary-color);\n}\n\n#doses .dose-entry.letter .time {\n  font-size: 1.5rem;\n}\n\n#doses .dose-entry.letter .dose-size {\n  top: 0.25rem;\n}\n\n#doses .dose-size .size.letter {\n  font-size: 1.32rem;\n}\n\n#doses .dose-size .ml {\n  margin-inline-start: 5px;\n  color: var(--light-grey-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
